import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type CommandData = PildomModules.Majic.Data.CommandData

export class Command extends BaseModel<CommandData> {
    override endPoint: string = 'majic/commands'
    override translationKey: string = 'majic.commands'
    override permissionName: string = 'majic_command'
    legendPictoUrl: string = 'majic/map-legend/commands.png'

    public async askCode(uuid: string, showToaster: boolean = true): Promise<any> {
        return await this.$api.setRequest({
            url: `majic/code/${uuid}`,
            method: 'POST',
            translation: showToaster ? `${this.getTranslationKey()}.codeRequest` : undefined,
        })
    }

    public async downloadFile(uuid: string, code: string, showToaster: boolean = true): Promise<any> {
        return await this.$api.setRequest({
            url: `majic/download/${uuid}`,
            method: 'POST',
            body: { code },
            responseType: 'blob',
            translation: showToaster ? `${this.getTranslationKey()}.fileDownloaded` : undefined,
        })
    }
}
